import {Component, Input} from '@angular/core';

@Component({
  selector: 'dcp-contact-us-link',
  templateUrl: './contact-us-link.component.html',
  styleUrls: ['./contact-us-link.component.scss'],
  standalone: false,
})
export class ContactUsLinkComponent {
  @Input() innerText: string = 'configurator.error.contactUsLink';
  @Input() isEnd: boolean = true;
  @Input() errorMessage?: string;
}
